import React, { useState, useEffect } from "react";
import Modal from './Modal';
import InputText from '../form/FormInputText';
import ButtonPrimary from '../button/ButtonPrimary';

export default function ModalSingleInput({ title, label, isActive, onClose, onSubmit, error, ...others }) {
    const [value, setValue] = useState('');

    function onValueChanged(e) {
        setValue(e.target.value);
    };

    function submission(event) {
        if(event) {
            event.preventDefault();
        }
        onSubmit(value);
    };

    return isActive && <Modal onClose={() => onClose(false)}>
        <h3 className="modal__content-title textAlign--center margin__bottom--m">{title}</h3>
        <form onSubmit={submission} id="frmModalSingleInput">
            <InputText label={label} name="name" id="txtModalSingleInput" required={true} onChange={onValueChanged}  />
            { error !== "" &&
                <p id="inputError" className="small input__error">{error}</p>
            }
            <div className="textAlign--right">
                <ButtonPrimary id="btnModalSingleInputSave" type="submit" text="Save" className="button--regular margin__top--m"/>
            </div>
        </form>
    </Modal>
}